import { render, staticRenderFns } from "./EditHomeOwners.vue?vue&type=template&id=0fa53cbe&scoped=true&"
import script from "./EditHomeOwners.vue?vue&type=script&lang=js&"
export * from "./EditHomeOwners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa53cbe",
  null
  
)

export default component.exports